<template>
  <v-container style="height: 100%; width: 100%" fluid class="login-container" no-gutters>
    <v-app-bar class="custom-app-bar" app>
      <v-toolbar-title class="align-left">
        <img src="~@/assets/csg-transformed.png" style="width: 50%" alt="logo" />
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn text @click="handleMenuItemClick('Contact Support')">Contact Us</v-btn>
    </v-app-bar>
    <v-container fluid fill-height>
      <v-row v-if="!otpScreen" no-gutters class="mt-2 mb-4 row align-center">
        <v-col sm="12" class="login-modal">
          <v-card elevation="2" height="100%" width="500" style="background-color: rgba(255, 255, 255, 0.9)">
            <v-toolbar :style="{ backgroundColor: computedBackgroundColor }">
              <v-toolbar-title style="color: white">Sign In</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <form ref="form" @submit.prevent="login">
                <v-text-field v-model="username" name="username" label="email" type="text" placeholder="email"
                  required></v-text-field>

                <v-text-field v-model="password" name="password" label="password" type="password" placeholder="password"
                  required></v-text-field>
                <v-row>
                  <v-col class="align-center">
                    <v-btn Contained class="mt-4" color="primary" value="log in" type="submit" style="width: 55%"
                      :style="{ backgroundColor: computedBackgroundColor }">submit</v-btn>
                  </v-col>
                </v-row>
                <v-row class="align-right">
                  <v-col>
                    <v-btn text class="mt-4 small-font" color="primary" @click="openForgotPW" value="forgot">Forgot
                      Password</v-btn>
                  </v-col>
                </v-row>
                <v-row class="align-center">
                  <v-col>
                    <a style="text-allign:center; text-decoration:none; color:black" class="clickable-link" href="https://www.csgi.com/privacy/privacy-notice/" target="_blank" rel="noopener noreferrer"><span class="clickable-link">Privacy Policy</span></a>
                  </v-col>
                </v-row>
              </form>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <otp-screen v-if="otpScreen"></otp-screen>
    </v-container>
    <view-footer></view-footer>
    <v-dialog v-model="modalOpen" max-width="500">
      <v-card>
        <v-card-title>
          <span class="headline">Required Values</span>
        </v-card-title>
        <v-card-text>
          <form ref="form" @submit.prevent="setNewPassword">
            <v-text-field v-model="newPassword" name="newPassword" label="New Password" type="password"
              placeholder="new password" required></v-text-field>
            <v-text-field v-model="firstName" name="firstName" label="First Name" type="firstName" placeholder="John"
              required></v-text-field>
            <v-text-field v-model="lastName" name="lastName" label="Last Name" type="lastName" placeholder="Smith"
              required></v-text-field>
            <v-row class="align-center">
              <v-col>
                <v-btn text class="mt-4" color="primary" @click="closeModal">Cancel</v-btn>
              </v-col>
              <v-col>
                <v-btn text class="mt-4" color="primary" value="log in" type="submit">Submit</v-btn>
              </v-col>
            </v-row>
          </form>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="modalPWOpen" max-width="500">
      <v-card>
        <v-card-title>
          <span class="headline">Reset Password</span>
        </v-card-title>
        <v-card-text>
          <form ref="form" @submit.prevent="resetPassword">
            <v-text-field v-model="username" name="username" label="Username" type="text" placeholder="username"
              required></v-text-field>
            <v-row class="align-center">
              <v-col>
                <v-btn text class="mt-4" color="primary" value="log in" type="submit">Submit</v-btn>
              </v-col>
              <v-col>
                <v-btn text class="mt-4" color="primary" @click="closeForgotPW">Cancel</v-btn>
              </v-col>
            </v-row>
          </form>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="modalVerify" max-width="500">
      <v-card>
        <v-card-title>
          <span class="headline">Reset Password</span>
        </v-card-title>
        <v-card-text>
          <form ref="form" @submit.prevent="confirmForgotPW">
            <v-text-field v-model="username" name="username" label="Username" type="text" placeholder="username"
              required></v-text-field>
            <v-text-field v-model="newPassword" name="newPassword" label="New Password" type="password"
              placeholder="new password" required @input="checkPasswordRequirements"></v-text-field>
            <div style="text-align: left">
              <ul class="validation-list">
                <li class="validation-item" :style="{ color: passwordRequirements.lowercaseLetterColor }">
                  <span class="material-icons validation-icon">
                    check_circle
                  </span>
                  <span class="validation-text">
                    Contains
                    at least 1 lowercase
                    letter</span>
                </li>
                <li class="validation-item" :style="{ color: passwordRequirements.uppercaseLetterColor }">
                  <span class="material-icons validation-icon">
                    check_circle
                  </span>
                  <span class="validation-text">Contains at
                    least 1 uppercase
                    letter</span>

                </li>
                <li class="validation-item" :style="{ color: passwordRequirements.specialCharacterColor }">
                  <span class="material-icons validation-icon">
                    check_circle
                  </span>
                  <span class="validation-text">Contains at
                    least 1 special
                    character</span>

                </li>
                <li class="validation-item" :style="{ color: passwordRequirements.numberColor }">
                  <span class="material-icons validation-icon">
                    check_circle
                  </span>
                  <span class="validation-text">Contains at least 1
                    number</span>

                </li>
                <li class="validation-item" :style="{ color: passwordRequirements.totalLengthColor }">
                  <span class="material-icons validation-icon">
                    check_circle
                  </span>
                  <span class="validation-text">Total length
                    must be at least 8
                    characters</span>
                </li>
              </ul>
            </div>
            <v-text-field v-model="verificationCode" name="verificationCode" label="Verification Code" type="password"
              placeholder="Enter Code" required></v-text-field>
            <v-row class="align-center">
              <v-col>
                <v-btn text class="mt-4" color="primary" :disabled="!passwordRequirements.isAllPassed" value="log in"
                  type="submit">Submit</v-btn>
              </v-col>
              <v-col>
                <v-btn text class="mt-4" color="primary" @click="closeVerify">Cancel</v-btn>
              </v-col>
            </v-row>
          </form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { Auth } from "aws-amplify";
import { mapActions, mapState } from "vuex";
import OtpScreen from "../components/templates/Otp.vue";
import ViewFooter from "../components/templates/ViewFooter.vue";

export default {
  name: "LoginView",
  components: {
    OtpScreen,
    ViewFooter
  },
  data: () => ({
    username: "",
    password: "",
    newPassword: "",
    modalOpen: false,
    modalPWOpen: false,
    modalVerify: false,
    otpScreen: false,
    // newsLetter: "",
    company: "Hippo",
    lastName: "",
    firstName: "",
    verificationCode: "",
    hasError: false,
    backgroundColor: "rgba(255, 1, 1, 0.9)",
    dialog: false,
    strText: "",
    strTitle: "",
    passwordRequirements: {
      successColor: '#1976d2',
      defaultColor: '#00000099',
      lowercaseLetterColor: '#00000099',
      uppercaseLetterColor: '#00000099',
      specialCharacterColor: '#00000099',
      numberColor: '#00000099',
      totalLengthColor: '#00000099',
      isAllPassed: false
    }
  }),
  methods: {
    async resetPassword() {
      try {
        await Auth.forgotPassword(this.username);

        this.closeForgotPW();
        this.modalVerify = true;
      } catch (error) {
        if (error.message === "Attempt limit exceeded, please try after some time.") {
          this.closeForgotPW();
          this.strText = "Too many recent attempts.  Please wait 15 minutes and try again.";
          this.strTitle = "Limit Exceeded";
          this.showModal(this.strText, this.strTitle);
        }
      }
    },
    showModal(strText, strTitle) {
      this.$store.commit("toggleDialog", { show: true, text: strText, titleText: strTitle });
    },
    async login() {
      try {
        const user = await Auth.signIn({
          username: this.username,
          password: this.password,
        });
        if (user.signInUserSession != null) {
          const groups = user.signInUserSession.accessToken.payload["cognito:groups"] || [];
          // eslint-disable-next-line
          user.company = groups[0];
        }
        this.setUser(user);
        // console.log("user", user);
        // if (user.challengeName === "SMS_MFA") {
        //   // this.openModal();
        //   this.otpScreen = true;
        // }
        if (user?.challengeName === 'CUSTOM_CHALLENGE') {
          this.otpScreen = true;
        }
        if (user.challengeName === "NEW_PASSWORD_REQUIRED") {
          this.openModal();
        } else {
          // this.$store.commit('setAuthentication', true);
          // this.$router.push('/Home');
        }
      } catch (error) {
        if (
          error.message === "Temporary password has expired and must be reset by an administrator."
        ) {
          // this.openForgotPW()
          await Auth.forgotPassword(this.username);
        } else if (error.message === "Incorrect username or password.") {
          this.strText = error.message;
          this.strTitle = "Login Error";
          this.showModal(this.strText, this.strTitle);
          this.hasError = true;
          // this.computedBackgroundColor;
          // Handle other login errors
        }
      }
    },
    async setNewPassword() {
      const { newPassword } = this;
      const attributes = {
        preferred_username: this.username, // Include preferred_username attribute
        family_name: this.lastName,
        given_name: this.firstName,
      };
      await Auth.completeNewPassword(this.user, newPassword, attributes);
      // this.$store.commit('setAuthentication', true);
      // this.$router.push('/Home');
      // this.otpScreen = true;
      this.closeModal();
    },
    async confirmForgotPW() {
      try {
        await Auth.forgotPasswordSubmit(this.username, this.verificationCode, this.newPassword);

        this.closeVerify();
        this.strText = "You have successfully reset your password.";
        this.strTitle = "Password Reset";
        this.showModal(this.strText, this.strTitle);
        // Optionally, you can show a success message to the user or redirect to a login page.
      } catch (error) {
        // Handle any errors that may occur during the password reset process.
      }
    },
    handleMenuItemClick(item) {
      // Handle the menu item click event

      switch (item) {
        case "Sign Out":
          this.logOut();
          break;
        case "CSConnect":
          window.open(`https://mpconnect.csgsupport.com/CIS/login/${this.company}`, "_blank");
          break;
        case "CSArchive":
          this.$router.push("/csarchive");
          break;
        case "CSCancel":
          this.$router.push("/cscancel");
          break;
        case "Contact Support":
          this.$router.push("/help");
          break;
        default:
          break;
      }
    },
    openModal() {
      this.modalOpen = true;
    },
    closeModal() {
      this.modalOpen = false;
    },
    openForgotPW() {
      this.modalPWOpen = true;
    },
    closeForgotPW() {
      this.modalPWOpen = false;
    },
    closeVerify() {
      this.modalVerify = false;
    },
    checkPasswordRequirements() {
      const lowercaseRegex = /[a-z]/;
      const uppercaseRegex = /[A-Z]/;
      const specialCharacterRegex = /[!@#$%^&*]/;
      const numberRegex = /\d/;
      const totalLengthRegex = /^.{8,}$/;

      this.passwordRequirements.lowercaseLetterColor = lowercaseRegex.test(this.newPassword) ? this.passwordRequirements.successColor : '#00000099';
      this.passwordRequirements.uppercaseLetterColor = uppercaseRegex.test(this.newPassword) ? this.passwordRequirements.successColor : '#00000099';
      this.passwordRequirements.specialCharacterColor = specialCharacterRegex.test(this.newPassword) ? this.passwordRequirements.successColor : '#00000099';
      this.passwordRequirements.numberColor = numberRegex.test(this.newPassword) ? this.passwordRequirements.successColor : '#00000099';
      this.passwordRequirements.totalLengthColor = totalLengthRegex.test(this.newPassword) ? this.passwordRequirements.successColor : '#00000099';

      this.passwordRequirements.isAllPassed = this.passwordRequirements.lowercaseLetterColor === this.passwordRequirements.successColor && this.passwordRequirements.uppercaseLetterColor === this.passwordRequirements.successColor && this.passwordRequirements.specialCharacterColor === this.passwordRequirements.successColor && this.passwordRequirements.numberColor === this.passwordRequirements.successColor && this.passwordRequirements.totalLengthColor === this.passwordRequirements.successColor
    },
    ...mapActions(["setUser"]),
  },
  computed: {
    ...mapState(["user"]),
    computedBackgroundColor() {
      // Replace this logic with your desired condition to set the background color dynamically
      if (this.hasError) {
        return "red"; // Set the background color to red when there's an error
      }
      return "rgba(0, 0, 0, 0.8)"; // Default background color when no error
    },
  },
};
</script>
<style>
.validation-list {
  padding-left: 0 !important;
  margin-top: 10px;
  margin-bottom: 20px;
}

.validation-icon {
  font-size: 20px;
}

.validation-item {
  display: flex;
  align-items: center;
  padding-block: 4px;
}

.validation-text {
  margin-left: 10px;
}


.login-container {
  background-image: url("~@/assets/background.png");
  /* Replace with the path to your PNG image */
  background-size: cover;
  background-position: center;
  min-height: 100vh;
}

.login-modal {
  display: flex;
  justify-content: center;
  /* Horizontally center-align */
  align-items: center;
  /* Vertically center-align */
}

.login-window {
  background-color: navy;
}

.custom-app-bar {
  background-color: white;
}

.align-left {
  text-align: left;
}

.align-right {
  text-align: right;
}

.align-center {
  align-items: center;
}

.small-font {
  font-size: 10px;
}

.row.align-center {
  align-items: center;
}

.v-slider__thumb {
  cursor: pointer;
}

.wrongPassword {
  background-color: rgb(255, 0, 0);
}

.clickable-link {
  padding-right: 10px;
  cursor: pointer;
  /* Add a pointer cursor to indicate the element is clickable */
}
</style>
